import { Status } from '@bitcine/cinesend-theme/dist'
import { useQuery } from '@tanstack/react-query'
import { Navigate } from 'react-router-dom'

// Grab the airlines, redirect to the first cycle of the first airline
// Perhaps in the future we can leverage local storage to return them to the last cycle they were viewing?
const LandingPage = () => {
  const { data: airlines, isLoading, error } = useQuery(['airlines'])

  return (
    <Status className='h-screen w-screen' pending={isLoading} error={error}>
      <Navigate to={`/airlines/${airlines?.[0]?.id}/cycles/${airlines?.[0]?.cycles[0]?.id}`} replace={true} />
    </Status>
  )
}

export default LandingPage
